import { useTranslation } from '@spcc/core'
import { PageToolbar } from '@spcc/uikit'
import { getFilterOptions } from '../utils'
import type { ShipmentsToolbarProps } from '../types'

export function ShipmentsToolbar({
  searchValue,
  onSearchChange,
  filterValue,
  onFilterChange,
  viewMode,
  onViewModeChange,
  isArabic,
}: ShipmentsToolbarProps) {
  const { t } = useTranslation()

  return (
    <PageToolbar
      searchPlaceholder={t('shipments.searchPlaceholder')}
      searchValue={searchValue}
      onSearchChange={onSearchChange}
      filterOptions={getFilterOptions(t)}
      filterValue={filterValue}
      onFilterChange={onFilterChange}
      showViewToggle={true}
      viewMode={viewMode}
      onViewModeChange={onViewModeChange}
      isRTL={isArabic}
    />
  )
}
